import { Alert, Button, Col, Form, FormFeedback, FormGroup, FormText, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../context';
import BtxSwitch from '../Forms/BtxSwitch';
import moment from 'moment';

const LeadsGenerationConfirmationModal = () => {

    const dispatch = useDispatch();

    // Modal visibility and practice information
    const {
        isLeadsGenerationConfirmationModalOpen,
        practiceId,
        practiceName,
    } = useSelector(
        (state) => ({
            isLeadsGenerationConfirmationModalOpen: state.toggle.isLeadsGenerationConfirmationModalOpen,
            practiceId: state.practice.practice?.id,
            practiceName: state.practice.practice?.name,
        }),
        shallowEqual
    );


    // Leads Generation configs
    const [message, setMessage] = useState('');
    const [isOverride, setOverrideFlag] = useState(false);
    const [startDate, setStartDate] = useState(moment.utc().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment.utc().format('YYYY-MM-DD'));
    const [datesAreValid, setDatesAreValid] = useState(true);
    const tz = moment().tz("utc").zoneAbbr();

    const handleCloseLeadsGenerationModal = () => {
        resetForm();
        dispatch(actions.toggle.toggleLeadsGenerationConfirmationModal(false));
    }

    const resetForm = () => {
        setMessage('');
        setOverrideFlag(false);
        setStartDate(moment.utc().format('YYYY-MM-DD'));
        setEndDate(moment.utc().format('YYYY-MM-DD'));
        setDatesAreValid(true);
    }

    const handleSetOverride = (e) => {
        setOverrideFlag(!isOverride);
    }

    const handleStartDateChange = (e) => {
        let newDate = moment(e.target.value).utc().format('YYYY-MM-DD');
        setStartDate(newDate);
        setDatesAreValid(newDate <= endDate ? true : false);
    }

    const handleEndDateChange = (e) => {
        let newDate = moment(e.target.value).utc().format('YYYY-MM-DD');
        setEndDate(newDate);
        setDatesAreValid(startDate <= newDate ? true : false);
    }

    const submit = async (e) => {
        e.preventDefault(); // prevent actual form submission from reloading the page
        doLeadsGeneration(practiceId, message, dispatch);
        resetForm();
    };

    const doLeadsGeneration = (practiceId, message, dispatch) => {

        // Set up leads generation configs as XML string
        // Set the time component of start and end dates to 00:00:00.000Z and 23:59:59.999Z (UTC) respectively
        const configXMLString = 
`<LeadsGenerationConfiguration>
    <ReasonText>${message}</ReasonText>
    <StartTime>${moment.utc(startDate).startOf('day').toISOString()}</StartTime>
    <EndTime>${moment.utc(endDate).endOf('day').toISOString()}</EndTime>
    <IsOverride>${isOverride}</IsOverride>
</LeadsGenerationConfiguration>`;

        console.log(configXMLString);

        dispatch(actions.practice.triggerManualPracticeLeadsGeneration(practiceId, configXMLString))
            .then(() => dispatch(actions.notes.fetchNotes(message)));

        handleCloseLeadsGenerationModal();
    }

    const setOverrideFormGroup = () => {
        return (
            <FormGroup>
                <Row>
                    <Col className="d-flex align-items-center justify-content-end">
                        <Label>{'Set override job'}</Label>
                    </Col>
                    <Col>
                        <BtxSwitch
                            value={isOverride}
                            onChange={handleSetOverride}>
                        </BtxSwitch>
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    const setStartDateFormGroup = () => {
            return (
                <FormGroup>
                    <Label>{`Set start date (MM/DD/YYYY): ${moment(startDate).format('MM/DD/YYYY')} 00:00 ${tz}`}</Label>
                    <Input
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        valid={startDate !== "Invalid Date"}
                        invalid={!datesAreValid || startDate === "Invalid date"}
                    ></Input>
                </FormGroup>
            );
    }

    const setEndDateFormGroup = () => {
            return (
                <FormGroup>
                    <Label>{`Set end date (MM/DD/YYYY): ${moment(endDate).format('MM/DD/YYYY')} 23:59 ${tz}`}</Label>
                    <Input
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        valid={endDate !== "Invalid date"}
                        invalid={!datesAreValid || endDate === "Invalid date"}
                    ></Input>
                </FormGroup>
            );
    }

    const showDateWarning = () => {
        if (!datesAreValid && (startDate !== "Invalid date" && endDate !== "Invalid date")) {
            return <Alert color="danger" text="primary">Error: start date is after the end date.</Alert>;
        }
        if (startDate === "Invalid date" || endDate === "Invalid date") {
            return <Alert color="danger" text="primary">Error: invalid date(s).</Alert>;
        }
    };

    return (
        <Modal
            isOpen={isLeadsGenerationConfirmationModalOpen}
            centered
            className="text-light"
            toggle={() => handleCloseLeadsGenerationModal()}
            autoFocus={false}>
            <Form onSubmit={submit}>
                <ModalHeader>Confirm Leads Generation for "{practiceName}"</ModalHeader>
                <ModalBody>
                    <Input autoFocus={true} value={message} onChange={e => setMessage(e.target.value)} type='textarea' placeholder={`Please include a reason for this leads generation job.`}></Input>
                    <FormText></FormText>
                </ModalBody>
                <Row>
                    <Col>
                        {setStartDateFormGroup()}
                    </Col>
                    <Col>
                        {setEndDateFormGroup()}
                    </Col>
                </Row>
                {setOverrideFormGroup()}
                {showDateWarning()}
                <ModalFooter>
                    <Button color='primary' onClick={resetForm}>Reset</Button>
                    <Button type='submit' color='success' disabled={!datesAreValid || startDate === "Invalid date" || endDate === "Invalid date"}>Submit</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default LeadsGenerationConfirmationModal;